const prefix = `com.mobilitycare.natalconnect:`;

export const storage = {
  local: {
    get: (key, defaultValue = undefined) => {
      const payload = localStorage.getItem(`${prefix}${key}`);

      return payload ? JSON.parse(payload) : defaultValue;
    },
    set: (key, value) => {
      if (value === undefined) {
        localStorage.removeItem(`${prefix}${key}`);

        return;
      }

      localStorage.setItem(`${prefix}${key}`, JSON.stringify(value));
    },
    clear: (key) => {
      localStorage.removeItem(`${prefix}${key}`);
    },
  },
};
